<template lang="pug">
  #MySa.d-flex.flex-column(
    style="height: calc(100% - 120px)"
  )
    .container-width.text-center.w-100(
      style="flex: 1 1 0;"
    )
      .pt-5
        img.pt-5.pb-3(
          :src='okImg',
          alt='success_ok_img',
          width="74"
        )
        p.font-weight-bold.mb-0 綁定成功
        hr.border-primary.w-100
        small.d-block.mb-0.px-4 恭喜您已完成專屬顧問綁定，
        small.d-block.mb-0.px-4 隨時與您的專屬顧問進行線上一對一諮詢。
    button.btn.btn-block.btn-primary(
      type="button",
      @click="backToLINEHandler()"
    ) 返回官方帳號

    .redirectDialog(v-if="redirectPage === 'sticker'") 即將為您轉導至貼圖下載頁面，請勿關閉頁面。

</template>

<script>
import { mapState } from 'vuex';
import okImgUrl from '@/assets/images/icon/icon_ok.png';

export default {
  name: 'BindSaSuccess',
  data() {
    return {
      okImg: okImgUrl,
      redirectPage: '',
    };
  },
  mounted() {
    const vm = this;
    vm.$store.commit('toggleLoading', false);
    vm.redirectPage = window.sessionStorage.getItem('directBy');
    if (vm.redirectPage === 'sticker') {
      let data = {
        line_uuid: window.sessionStorage.getItem('line_uuid'),
        msg_channel_id: process.env.VUE_APP_LINE_MESSAGE_CHANNEL_ID
      }
      
      vm.$store.dispatch('member_sign_up/getMissionStickerHandler', data)
        .then(() => {
          window.location.href = process.env.VUE_APP_LINE_STICKER_URL;
        })
    }
  },
  methods: {
    backToLINEHandler() {
      window.location = process.env.VUE_APP_LINE_ADD_FRIEND_LINK;
    }
  },
  computed: {
    ...mapState({
      saInfo: (state) => state.member_bind_sa.saInfo
    })
  },
  computed: {
  }
};
</script>

<style lang="scss" scoped>
.redirectDialog {
  width: 70%;
  max-width: 240px;
  border: solid 3px;
  background: #fff;
  padding: 45px 25px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
